import { connect, Dispatch } from 'react-redux';

import {
    IRootState
} from 'redux/root_reducer';

import {
    Action,
    add,
    cartMessage,
    remove
} from 'redux/modules/shopify';

import InventoryDetail, {
    DispatchProps,
    OwnProps,
    StateProps
} from 'components/pages/inventory/detail/InventoryDetail';

import CartItem from 'types/shopify/CartItem';

const mapStateToProps = ({ display, inventory_filter_data, shopify }: IRootState): StateProps => ({
    cartItems: shopify.cartItems,
    category_options: inventory_filter_data.categories,
    isMobile: display.isMobile,
    product: false
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        addToCart: (item: CartItem) => dispatch(add(item)),
        displayCartMessage: (value: string) => dispatch(cartMessage(value)),
        removeItem: (item: CartItem) => dispatch(remove(item)),
    };
};

export default connect<StateProps, {}, OwnProps>(mapStateToProps, mapDispatchToProps)(InventoryDetail);



// WEBPACK FOOTER //
// ./src/containers/pages/inventory/detail/InventoryDetail.tsx